export const habaAddress = {
  habaAddressForm: {
    heading: "Wohin geht's?",
    section: {
      billingAddress: 'Rechnungsadresse',
      shippingAddress: 'Lieferadresse',
      address: 'Adresse',
      title: 'Anrede',
    },
    useThisShippingAddress: 'An diese Adresse senden',
    useThisBillingAddress: 'Als Rechnungsadresse verwenden',
    personalData: 'Wie lauten deine persönlichen Daten?',
    newAddressHeadline: 'Neue Adresse hinzufügen',
    newAddressButton: 'Adresse hinzufügen',
    editNewAddressHeadline: 'Address bearbeiten',
    saveAddress: 'Addresse Speichern',
    submitChanges: 'Änderungen Speichern',
    billingAddressRequired: 'Sie müssen eine Rechnungsadresse auswählen',
    deliveryAddressRequired: 'Sie müssen eine Lieferadresse auswählen',
    deliveryAddressCountryMismatch:
      'Die gewählte Lieferadresse gehört nicht zu diesem Shop. Bitte wähle eine Lieferadresse aus diesem Land aus oder lege eine neue an.',
    editDeliveryAddress: 'Lieferadresse bearbeiten',
    editBillingAddress: 'Rechnungsadresse bearbeiten',
    editDeliveryMethod: 'Versandart bearbeiten',
    editPaymentMethod: 'Zahlungsart bearbeiten',
    editEmailAddress: 'E-Mail Adresse bearbeiten',
    form: {
      privateCompanyToggle: {
        private: 'Privatkunde',
        company: 'Firmenkunde',
      },
      firm: 'Firma',
      title: {
        label: 'Anrede*',
        error: 'Bitte Anrede auswählen',
      },
      firstName: {
        label: 'Vorname*',
        error: 'Bitte Vorname eingeben',
      },
      lastName: {
        label: 'Nachname*',
        error: 'Bitte Nachname eingeben',
      },
      name: {
        label: 'Name*',
        error: 'Bitte Name eingeben',
      },
      year: {
        label: 'Jahr',
        labelRequired: 'Jahr*',
        error: 'Bitte Jahr eingeben',
      },
      month: {
        label: 'Monat',
        labelRequired: 'Monat*',
        error: 'Bitte Monat eingeben',
      },
      day: {
        label: 'Tag',
        labelRequired: 'Tag*',
        error: 'Bitte Tag eingeben',
      },
      companyName: {
        label: 'Firma*',
        error: 'Bitte Firma eingeben',
      },
      address1: {
        label: 'Straße*',
        error: 'Bitte Straße eingeben',
      },
      nr: {
        label: 'Nr*',
        error: 'Bitte Nr eingeben',
      },
      address2: {
        label: 'Adresszusatz (optional)',
      },
      country: {
        label: 'Land*',
        error: 'Bitte Land auswählen',
      },
      city: {
        label: 'Ort*',
        error: 'Bitte Ort eingeben',
      },
      zipCode: {
        label: 'PLZ*',
        errorRequired: 'Bitte gib eine PLZ an.',
        errorDefault: 'Bitte überprüfe, ob das Format der eingegebenen Postleitzahl korrekt ist.',
        pattern: {
          errorMainText: 'Bitte überprüfe, ob die eingegebene Postleitzahl korrekt ist. Format: ',
          // following the zip code example patterns (that are shown after "errorMainText")
          '^[0-9]{3}$': '123',
          '^[0-9]{4}$': '1234',
          '^[0-9]{5}$': '12345',
          '^AD[1-7]00$': 'AD100',
          '^(FO-)?[0-9]{3}$': 'FO-100',
          '^GX11 1AA$': 'GX11 1AA',
          '^[A-Za-z0-9]{3} [A-Za-z0-9]{4}$': 'A99 A9A9',
          '^MD-[0-9]{4}$': 'MD-9999',
          '^[A-Za-z]{2,3} [0-9]{4}$': 'AAA 9999',
          '^[0-9]{4} ?[A-Za-z]{2}$': '9999ZZ',
          '^[0-9]{2}-[0-9]{3}$': '99-999',
          '^[0-9]{4}-[0-9]{3}$': '9999-999',
          '^[0-9]{3}[ -]?[0-9]{2}$': '999 99',
          '^[0-9]{3} ?[0-9]{2}$': '999 99',
        },
      },
      lengthError: 'Dieses Feld ist ein Pflichtfeld und muss zwischen 1 und 255 Zeichen umfassen',
      dayLengthError: 'ungültiger Tag',
      monthLengthError: 'ungültiger Monat',
      yearLengthError: 'ungültiger Jahr',
      phone: {
        required: 'Bitte Telefonnummer eingeben',
        pattern: 'Keine gültige Telefonnummer',
      },
    },
    billingAddress: {
      selectAddress: 'Wähle die mit deiner Karte oder Zahlungsmethode verknüpfte Adresse aus.',
      sameWithShippingAddress: 'Mit der Lieferadresse identisch',
    },
    selectDifferentDeliveryAddress: 'Andere Lieferadresse auswählen',
    selectDifferentBillingAddress: 'Andere Rechnungsadresse auswählen',
    choose: 'Auswählen',
    salesForPrivateMatters:
      'Der Verkauf erfolgt ausschließlich zur privaten, nicht kommerziellen Nutzung durch den Kunden.',
    birthdate: 'Geburtsdatum',
    optinalInformation: 'Optionale Kontaktinformationen',
    updateAccountButtonText: 'DATEN ÄNDERN & SPEICHERN',
    customerDetailsUpdatedSuccesfully: 'Ihre Kundendaten wurden gerade aktualisiert',
  },
  habaAddressMelissa: {
    heading: 'Adressprüfung',
    paragraph:
      'Lieber Kunde, leider ist uns deine Adresse nicht bekannt. Bitte überprüfe diese Adressvorschläge und bestätige deine Adresse',
    suggestions: 'Meintest du vielleicht:',
    yourInput: 'Deine Eingabe:',
    submitButton: 'AUSWAHL ÜBERNEHMEN & WEITER',
  },
};
